import {
  buttons,
  cornerButtonsAdmin,
  cornerButtonsCustomer,
  iconButtons,
} from "../../../utils/helpers/helperDataset/lead-management-contents/LeadDetailsDatset";
import React from "react";
import { getIconForType, LeadIconType } from "./utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faMagnifyingGlassLocation,
  faPhone,
  faThumbsUp,
  faThumbsDown,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";
import Button from "../../atoms/Buttons/Button/Button";

interface LeadButtonsProps {
  selectedLead: any;
  userRole: string;
  MainHandleFunction: (e: React.MouseEvent<HTMLElement>, name: string) => void;
}

export const iconMap: Record<LeadIconType, JSX.Element> = {
  [LeadIconType.Viewers]: <FontAwesomeIcon icon={faUsers} />,
  [LeadIconType.Location]: <FontAwesomeIcon icon={faMagnifyingGlassLocation} />,
  [LeadIconType.Call]: <FontAwesomeIcon icon={faPhone} />,
  [LeadIconType.Approve]: <FontAwesomeIcon icon={faThumbsUp} />,
  [LeadIconType.Reject]: <FontAwesomeIcon icon={faThumbsDown} />,
  [LeadIconType.Chat]: <FontAwesomeIcon icon={faMessage} />,
};

const LeadButtons: React.FC<LeadButtonsProps> = ({
  selectedLead,
  userRole,
  MainHandleFunction,
}) => {
  return (
    <div className="button-section-lead">
      <div className="col-md-6 btn-wrapper">
        {userRole !== "Operator" &&
          iconButtons.filter((button) => {
            // Only show Identity Intelligence for Business leads
            if (
              button.name === "Identity Intelligence" &&
              selectedLead?.leadType !== "Business"
            ) {
              return false;
            }

            return true;
          }).map((button: any, index: number) => (
            <Button
              cssClass={
                button.name === "Identity Intelligence"
                  ? "btn-secondary company-btn"
                  : "btn-secondary"
              }
              text={button.name}
              icon={button.iconName}
              onClick={(e) => MainHandleFunction(e, button.name)}
              activeColor="#ffffff"
              key={index}
            />
          ))}

        {userRole === "Customer" &&
          buttons.map((button: any, key: number) => (
            <Button
              cssClass={
                button.name === "Identity Intelligence"
                  ? "btn-secondary company-btn"
                  : "btn-secondary"
              }
              text={button.name}
              icon={button.iconName}
              onClick={(e) => MainHandleFunction(e, button.name)}
              activeColor="#ffffff"
              key={key}
            />
          ))}
      </div>

      <div className="col-md-6 right-button">
        {(userRole === "Customer" ? cornerButtonsCustomer : cornerButtonsAdmin)
          .filter((button: any) =>
            userRole === "Operator" ? button.name !== "Delete" : true
          )
          .map((button: any, index: number) => (
            <Button
              key={index}
              cssClass={button.class1}
              onClick={(e) => MainHandleFunction(e, button.name)}
              text={button.name}
            />
          ))}
      </div>
    </div>
  );
};

export default LeadButtons;
